import './_brands-page.scss';

export default () => Component(function ($context) {
	return $context.select('.brands-search');
}, function ($block, self) {
	var $brandsList = $('.brands-page__brands');
	var $searchField = $block.find('.brands-search__input');
	var $clearSearch = $block.find('.brands-search__clear');
	var $lettersBlock = $block.find('.brands-letters');
	var $lettersLists = $lettersBlock.find('.brands-letters__list');
	var $lettersTogglers = $lettersBlock.find('.brands-letters__toggler');
	var letterActiveClass = 'brands-letters__item_active';
	var brandNameBlockSelector = '.manufacturer-card__name';
	var errorBlock = null;

	var _private = {
		searchString: '',
		letter: '',
		initEventListeners: function() {
			$searchField.on('input', function() {
				var value = this.value.toLowerCase();
				if (value.length > 0) {
					_private.searchString = value;
					$clearSearch.show();
				} else {
					_private.searchString = '';
					$clearSearch.hide();
				}

				_private.filterItems();
			});

			$searchField.on('focus', function () {
				$searchField.closest('.brands-search__field-wrapper').addClass('brands-search__field-wrapper_focus');
			});

			$searchField.on('blur', function () {
				$searchField.closest('.brands-search__field-wrapper').removeClass('brands-search__field-wrapper_focus');
			});

			$clearSearch.on('click', function () {
				$searchField.val('').trigger('input');
				$(this).hide();
			});

			$lettersBlock.on('click', '.brands-letters__item', function () {
				var $item = $(this);

				if ($item.hasClass(letterActiveClass)) {
					_private.letter = '';
					$item.removeClass(letterActiveClass);
				} else {
					$lettersBlock.find('.brands-letters__item').removeClass(letterActiveClass);
					$item.addClass(letterActiveClass);
					_private.letter = $(this).data('letter');
				}

				_private.filterItems();
			});

			$lettersTogglers.on('click', function () {
				var list = $(this).data('list');
				var $list = $lettersLists.filter('[data-list="'+list+'"]');

				$lettersTogglers.removeClass('brands-letters__toggler_active');
				$lettersLists.removeClass('brands-letters__list_active');

				$(this).addClass('brands-letters__toggler_active');
				$list.addClass('brands-letters__list_active');
			})
		},
		filterItems: function() {
			_private.getItems().each(function() {
				var $itemBlock = $(this);
				var $itemNameBlock = $itemBlock.find(brandNameBlockSelector);
				var itemName = $itemNameBlock.text().toLowerCase();
				var itemLetter = $itemBlock.data('letter');

				if (itemName.includes(_private.searchString) && (itemLetter === _private.letter || _private.letter === '')) {
					$itemBlock.show();
				} else {
					$itemBlock.hide();
				}
			});

			_private.toggleNotFoundBlock();
		},
		toggleNotFoundBlock: function() {
			var hasShownItems = _private.getItems().filter(':visible').length > 0;

			if (hasShownItems) {
				$brandsList.find('.brands-page__error-container').remove();
			} else if ($brandsList.find('.brands-page__error-container').length === 0) {
				if (errorBlock === null) {
					errorBlock = $block.data('error-block');
					$block.removeAttr('data-error-block');
				}
				$brandsList.append(errorBlock);
			}
		},
		getItems: function() {
			return $brandsList.find('.brands-page__brand');
		}
	};

	_private.initEventListeners();
})
